<template>
  <div class="card">
    <div
      class="card-body"
    >
      <p class="card-text mb-3">
        Xml Alternative Names
      </p>
      <div class="row">
        <div class="col-lg-6">
          <form @submit.prevent="search">
            <div
              class="form-group"
            >
              <label>Text</label>
              <input
                class="form-control"
                type="text"
                placeholder="Filter rules"
                v-model="text"
                @change="search"
              >
            </div>
            <div
              class="form-group"
            >
              <label>Location Id</label>
              <input
                class="form-control"
                type="text"
                placeholder="Filter rules"
                v-model="locationId"
                @change="search"
              >
            </div>
          </form>
        </div>
        <div class="col-lg-6">
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            @click="newAlt = true"
          >
            Add Alt Location name
          </button>
        </div>
      </div>
    </div>
    <div
      class="card-body"
      v-if="alternativeNames && alternativeNames.length > 0"
    >
      <table class="table table-striped">
        <thead>
          <th>Id</th>
          <th>Text</th>
          <th>Location Id</th>
          <th>Location Text</th>
          <th>Created By</th>
          <th>Created At</th>
          <th>Actions</th>
        </thead>
        <tbody>
          <tr
            v-for="alternativeName in alternativeNames"
            :key="alternativeName.id"
          >
            <td>{{ alternativeName.id }}</td>
            <td>{{ alternativeName.text }}</td>
            <td>{{ alternativeName.locationId }}</td>
            <td>{{ alternativeName.locationText }}</td>
            <td>{{ alternativeName.createdBy }}</td>
            <td>{{ toLocaleString( alternativeName.createdAt ) }}</td>
            <td>
              <button
                class="btn btn-outline-secondary"
                @click="removeAlternativeName ( alternativeName.id )"
              >
                remove alt name
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        class="alert alert-info"
        v-if="alternativeNames.length == 50"
      >
        Showing first 50 results
      </div>
    </div>
    <div
      :class="`modal fade px-0 ${ newAlt ? 'show d-block' : 'd-none'}`"
      tabindex="-1"
      role="dialog"
    >
      >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Add new alternative name
            </h5>
            <button
              type="button"
              class="close"
              @click="newAlt = false"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body container-fluid">
            <form @submit.prevent="addNewAlt">
              <div class="form-group">
                <label for="key">For text</label>
                <input
                  type="attribute"
                  class="form-control"
                  v-model="newAltText"
                  placeholder="For text"
                  required
                >
              </div>
              <div class="form-group">
                <label for="key">Resolve to</label>
                <vue-typeahead-bootstrap
                  placeholder="Start typing location ..."
                  v-model="query"
                  @hit="selectedLocation = $event"
                  :min-matching-chars="2"
                  :data="locations"
                  :serializer="item => item.displayName + ' (' + item.id + ' ' + item.type + ')'"
                  :disable-sort="true"
                  :show-all-results="true"
                  required
                />
              </div>
              <button
                class="btn btn-primary btn-block mt-2"
                type="submit"
              >
                Add
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import xmlimportsapi from '../../../xmlimportapi';
import notify from '../../../notifications';
import geospatialapi from '../../../geospatialapi';
import http from '../../../http';

let preloadedLocations = {};

export default {
    data() {
        return {
            alternativeNames: [],
            text: '',
            locationId: null,
            newAlt: false,
            newAltText: '',
            locations: [],
            selectedLocation: null,
            query: ''
        };
    },
    async mounted() {
        this.search();
    },
    watch: {
        query( q ) {
            this.loadLocations( q );
        }
    },
    methods: {
        toLocaleString( dateInString ) {
            if ( !dateInString ) {
                return '';
            }
            const date = new Date( dateInString );
            return date.toLocaleString( [ 'es-ES', 'en-UK' ] );
        },
        async search() {
            this.$store.dispatch( 'appLoading', true );

            var url = '/alternativename';

            const response = await xmlimportsapi.get( url );

            if ( response.status !== 200 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load rules'
                } );
                return;
            }

            let alternativeNames = await response.json();

            if ( this.text.length > 0 ) {
                let lowerText = this.text.toLowerCase();
                alternativeNames = alternativeNames.filter( alternativeName => alternativeName.text.toLowerCase().includes( lowerText ) );
            }

            if ( this.locationId ) {
                alternativeNames = alternativeNames.filter( alternativeName => alternativeName.locationId == this.locationId );
            }

            if ( alternativeNames.length > 50 ) {
                alternativeNames = alternativeNames.slice( 0, 50 );
            }

            await this.preloadLocations( alternativeNames );

            for ( let alternativeName of alternativeNames ) {
                alternativeName.locationText = this.toLocationText( preloadedLocations[ alternativeName.locationId ] );
            }

            this.alternativeNames = alternativeNames;

            this.$store.dispatch( 'appLoading', false );
        },
        toLocationText( location ) {
            if ( !location ) {
                return '';
            }

            let output = `${location.labels.es}`;

            let municipalities = location.parentLocations.filter( p => p.type == 'municipality' );
            if ( municipalities.length > 0 ) {
                output += `, municipality: ${municipalities.map( m => m.labels.es ).join( ', ' )}`;
            }

            let province = location.parentLocations.filter( p => p.type == 'province' );
            if ( province.length > 0 ) {
                output += `, province: ${province.map( p => p.labels.es ).join( ', ' )}`;
            }

            return output;
        },
        async removeAlternativeName( id ) {
            var r = confirm( 'Are you sure you want to remove alternative name?' );

            if ( !r ) {
                return;
            }

            var url = '/alternativename/' + id;

            const response = await xmlimportsapi.delete( url );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to remove alternative name'
                } );
                return;
            }

            notify( {
                type: 'info',
                title: 'Alternative name was removed'
            } );

            this.search();
        },
        async preloadLocations( alternativeNames ) {
            let locationIDs = [];

            for ( let altName of alternativeNames ) {
                if ( !preloadedLocations[ altName.locationId ] ) {
                    locationIDs.push( `id=${altName.locationId}` );
                }
            }

            if ( locationIDs.length == 0 ) {
                return;
            }

            // build url or form ?id=123&id=456
            let url = '/locations?' + locationIDs.join( '&' );

            const response = await geospatialapi.get( url );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load locations'
                } );
                return;
            }

            const locations = await response.json();

            for ( let location of locations ) {
                preloadedLocations[ location.id ] = location;
            }
        },
        async addNewAlt() {
            if ( this.selectedLocation == null ) {
                notify( {
                    type: 'error',
                    text: 'No location selection',
                    title: 'Please select location'
                } );
                return;
            }

            this.$store.dispatch( 'appLoading', true );

            let data = {
                text: this.newAltText,
                locationId: this.selectedLocation.id
            };

            const response = await xmlimportsapi.post( '/alternativename', data );

            if ( response.status !== 200 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to add new alternative name'
                } );
            }

            this.newAlt = false;
            this.$store.dispatch( 'appLoading', false );
        },
        async loadLocations( q ) {
            if ( !q || q.length < 2 ) {
                this.locations = [];
                return;
            }

            const response = await http.get( '/locationsuggestion?q=' + q );
            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load locations'
                } );
            } else {
                this.locations = await response.json();
            }
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/components/dashboard/xmlimport/alternativenames.vue